module.exports = {
  /**
   * 保存制作费分拆请求参数
   * @param {Object} entity 分拆信息实体
   * @returns
   */
  SaveProductionSplitsParam (entities) {
    return entities.map(t => SaveProductionSplitParam(t))
  },
};

const SaveProductionSplitParam = (entity) => {
  return {
    Id: entity.id,
    ProductionCost: entity.productionCost,
    RepaintingCost: entity.repaintingCost,
    DismantleCost: entity.dismantleCost,
    TotalCost: entity.totalCost,
    ContractId: entity.contractId,
    SplitDetailId: entity.splitDetailId,
    SplitMediaId: entity.splitMediaId,
    ContractMediaId: entity.contractMediaId
  };
}
